// extracted by mini-css-extract-plugin
export default {"dropdown":"PRMh6hnEBkubSwsBwt9Y"};